import { render, staticRenderFns } from "./_inventorySection.vue?vue&type=template&id=958366ce&scoped=true&"
import script from "./_inventorySection.vue?vue&type=script&lang=js&"
export * from "./_inventorySection.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "958366ce",
  null
  
)

export default component.exports